import { Box, Stack } from "@biblioteksentralen/react";
import { WorkPageRecommendation } from "../../../app/[locale]/sites/[siteDomain]/samling/verk/[workId]/fetchRecommendationData";
import BlockContent from "../../../components/blockContent/BlockContent";
import CreatedByTag from "../../../components/employees/CreatedByTag";
import { Teaser } from "../../../components/recommendation/Teaser";
import { useTranslation } from "../../../utils/hooks/useTranslation";
import { CollapsableWithGradient } from "./CollapsableWithGradient";
import { richTextToString } from "@libry-content/common";

interface Props {
  recommendation: WorkPageRecommendation;
}

const RecommendationCardForWorkView = ({ recommendation }: Props) => {
  if (!recommendation.publication) return null;

  return (
    <Stack gap="1rem">
      <Teaser recommendation={recommendation} />
      <CreatedByTag createdBy={recommendation.isLocal ? recommendation.createdBy : recommendation.site} />
      <Box display={{ base: "initial", md: "none" }}>
        <RecommendationToggleableText recommendation={recommendation}></RecommendationToggleableText>
      </Box>
      <Box display={{ base: "none", md: "initial" }}>
        <RecommendationToggleableText recommendation={recommendation}></RecommendationToggleableText>
      </Box>
    </Stack>
  );
};

interface PropsRecommendationToggleableText {
  recommendation: WorkPageRecommendation;
}

const RecommendationToggleableText = ({ recommendation }: PropsRecommendationToggleableText) => {
  const { t, ts, populateLang } = useTranslation();
  return (
    <CollapsableWithGradient
      maxWidth="30rem"
      readLessText={t("Les mindre")}
      readMoreText={t("Les hele anbefalingen")}
      isOverflowingGuess={richTextToString(ts(recommendation.description)).length > 150}
    >
      <BlockContent
        {...populateLang(recommendation.description)}
        fontSize="md"
        blocks={ts(recommendation.description)}
      />
    </CollapsableWithGradient>
  );
};

export default RecommendationCardForWorkView;
